import {
  collection,
  query,
  where,
  orderBy,
  endBefore,
  startAfter,
  limit,
  getCountFromServer,
  getDocs
} from 'firebase/firestore';
import { db } from '../../db';

export async function getCollectionPage(collectionPath, makeItem, options = {}) {
  const col = collection(await db, collectionPath);
  const orderByField = options.orderBy || 'id';
  const orderByNotNull = where(orderByField, '!=', null);
  const order = orderBy(orderByField);
  const boundary = options.startAfter
    ? startAfter(options.startAfter)
    : options.endBefore
      ? endBefore(options.endBefore)
      : startAfter(null);

  const constraints = [orderByNotNull];
  if (options.filters) {
    for (const field in options.filters) {
      if (options.filters[field] !== null) {
        constraints.push(where(field, '==', options.filters[field]));
      }
    }
  }

  const [totalSnap, offsetSnap, itemsSnap] = await Promise.all([
    getCountFromServer(query(col, ...constraints)),
    getCountFromServer(query(col, ...constraints, order, boundary)),
    getDocs(query(col, ...constraints, order, boundary, limit(options.pageSize || 25)))
  ]);

  const total = totalSnap.data().count;
  const boundaryOffset = offsetSnap.data().count;
  const items = itemsSnap.docs.map(docSnap => makeItem(docSnap));
  const offset = options.endBefore
    ? boundaryOffset - items.length
    : total - boundaryOffset;

  return {
    offset,
    total,
    items
  };
}
